var config = require('../config')

module.exports = {

  bind: function () {
    var el = this.el
    this.vm.$once('hook:compiled', function () {
      el.removeAttribute(config.prefix + 'cloak')
    })
  }

}


/*****************
 ** WEBPACK FOOTER
 ** ./src/directives/cloak.js
 ** module id = 37
 ** module chunks = 0
 **/